<div class="btn-group btn-group-toggle" data-toggle="buttons">
  <label class="btn btn-secondary btn-md" (click)="SortByHandler()" [ngClass]="SearchParam.SortBy =='Relevancy' ? 'active':''" for="optionRelevancy" title="Sort by relevancy">
      <input type="radio" name="options" id="optionRelevancy" [(ngModel)]="SearchParam.SortBy"
          [value]="'Relevancy'" /> Relevancy
  </label>
  <label class="btn btn-secondary btn-md"  (click)="SortByHandler(true)" [ngClass]="SearchParam.SortBy =='Date' ? 'active':''"  for="optionDate" title="Sort by posted date">
      <input type="radio" name="options" id="optionDate"  [(ngModel)]="SearchParam.SortBy"
          [value]="'Date'" /> Most Recent
  </label>
</div>